"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const close_1 = require("../icons/close");
exports.default = close_1.Close;
